import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.index + 1), 1)
      ], 64))
    : (_ctx.column.key === 'invoiceNumber')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: `/invoice/${_ctx.row.invoiceId}`,
          class: "text-blue-500",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row.invoiceNumber), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_ctx.column.key === 'cityName')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createTextVNode(_toDisplayString(_ctx.row.cityName) + " / " + _toDisplayString(_ctx.row.sectorName), 1)
          ], 64))
        : (_ctx.column.key === 'deliveryStatus' && _ctx.row.deliveryStatus)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 3,
              class: _normalizeClass(`small ${_ctx.getClass(_ctx.row.deliveryStatus.id)}`)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.row.deliveryStatus.title || '-'), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : (_ctx.column.key === 'waitListStatus' && _ctx.row.waitListStatus)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createTextVNode(_toDisplayString(_ctx.row.waitListStatus.title || '-'), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
              ], 64))
}